import React from "react";
import { Eye, Heart, Search } from "lucide-react";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
function NewArrivalsGrid() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div data-section-id="6850" className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="h-[400px] w-full animate-pulse rounded-none bg-muted/30" />)}
      </div>;
  }
  if (error) {
    return <div className="flex h-40 flex-col items-center justify-center text-center text-muted-foreground">
        <p>Unable to load our featured litters.</p>
      </div>;
  }
  if (products.length === 0) {
    return <div className="flex h-40 flex-col items-center justify-center text-center text-muted-foreground">
        <p>No puppies currently available. Please check back soon.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      {products.map((product, i) => {
      const gender = product.customFields?.gender || "Male";
      const status = product.customFields?.status || "Available";
      const genderColor = gender === "Female" ? "bg-primary text-primary-foreground" : "bg-primary/80 text-primary-foreground";
      const statusColor = status === "Reserved" ? "bg-muted text-muted-foreground" : "bg-secondary text-secondary-foreground";
      return <Card key={product.id} data-index={i} className="group overflow-hidden border-none bg-card shadow-sm transition-all hover:shadow-xl">
            {}
            <div className="relative aspect-[4/5] overflow-hidden rounded-none bg-muted">
              {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center bg-muted text-muted-foreground">
                  <span className="text-sm font-sans uppercase tracking-widest">Cavalier Portrait</span>
                </div>}

              {}
              <div className="absolute top-4 left-4 flex flex-col gap-2">
                <Badge variant="secondary" className={`${genderColor} border-none shadow-sm rounded-none px-3 py-1 font-sans text-[10px] uppercase tracking-wider`}>
                  {gender}
                </Badge>
                <Badge variant="outline" className={`${statusColor} border-none backdrop-blur-sm rounded-none px-3 py-1 font-sans text-[10px] uppercase tracking-wider`}>
                  {status}
                </Badge>
              </div>

              {}
              <div className="absolute inset-0 flex items-center justify-center bg-background/40 opacity-0 backdrop-blur-[2px] transition-opacity duration-300 group-hover:opacity-100">
                <Button asChild variant="secondary" size="default" className="shadow-lg rounded-none bg-background text-foreground hover:bg-primary hover:text-primary-foreground">
                  <Link to={product.link}>
                    <Eye className="mr-2 h-4 w-4" />
                    View Details
                  </Link>
                </Button>
              </div>
            </div>

            {}
            <CardContent className="flex flex-col gap-2 p-6">
              <div className="flex items-start justify-between">
                <Link to={product.link} className="hover:text-primary transition-colors">
                  <CardTitle className="text-2xl font-sans font-semibold tracking-tight text-foreground">{product.title}</CardTitle>
                </Link>
                <div className="text-xl font-bold text-primary">
                  ${product.price}
                </div>
              </div>
              
              {product.short_description && <div className="line-clamp-2 text-base text-muted-foreground font-sans leading-relaxed" dangerouslySetInnerHTML={{
            __html: product.short_description
          }} />}
              
              {}
              <div className="mt-4 flex items-center gap-6 text-[11px] font-sans uppercase tracking-widest text-muted-foreground">
                <span className="flex items-center gap-2">
                  <span className="h-1.5 w-1.5 rounded-full bg-secondary" />
                  {product.customFields?.age || "8 Weeks Old"}
                </span>
                <span className="flex items-center gap-2">
                  <span className="h-1.5 w-1.5 rounded-full bg-secondary" />
                  {product.customFields?.color || "Blenheim"}
                </span>
              </div>
            </CardContent>

            {}
            <CardFooter className="p-6 pt-0">
              <AddToCartButton productId={product.id} variant="default" className="w-full" buttonClassName="w-full bg-primary text-primary-foreground hover:bg-primary/90 rounded-none h-12 font-sans uppercase tracking-widest text-sm" text="Reserve Puppy" showQuantity={false} />
            </CardFooter>
          </Card>;
    })}
    </div>;
}
export default function NewArrivals() {
  const wp_query_params = {
    per_page: 3,
    orderby: "date",
    order: "desc",
    status: "publish"
  };
  const wp_query = new WP_Query(wp_query_params);
  return;
}